export const WORKLIST_SECTION_IDS = Object.freeze({
  CRITICAL: "worklist-fix-now",
  HIGH: "worklist-this-sprint",
  MEDIUM: "worklist-plan",
  LOW: "worklist-hygiene",
});

function normalizeStepText(value) {
  return String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();
}

export function normalizeRemediationSteps(steps) {
  if (Array.isArray(steps)) {
    return steps.filter((x) => typeof x === "string" && x.trim()).map((x) => x.trim());
  }
  if (steps && typeof steps === "object" && Array.isArray(steps.default)) {
    return steps.default.filter((x) => typeof x === "string" && x.trim()).map((x) => x.trim());
  }
  return [];
}

export function distinctRemediationSteps(summary, steps) {
  const summaryNorm = normalizeStepText(summary);
  const list = normalizeRemediationSteps(steps);
  const seen = new Set();
  if (summaryNorm) seen.add(summaryNorm);

  const distinct = [];
  for (const step of list) {
    const text = String(step || "").trim();
    const norm = normalizeStepText(text);
    if (!norm || seen.has(norm)) continue;
    seen.add(norm);
    distinct.push(text);
  }
  return distinct;
}

export function worklistSectionId(severity) {
  const key = String(severity || "").toUpperCase();
  return WORKLIST_SECTION_IDS[key] || "worklist-plan";
}

export function scrollToWorklistSection(sectionId) {
  const el = document.getElementById(sectionId);
  if (!el) return;
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const page = el.closest(".remediation-summary-page");
  const offsetRaw = page ? getComputedStyle(page).getPropertyValue("--remediation-sticky-offset") : "";
  const offset = Number.parseFloat(offsetRaw) || 0;
  if (offset > 0) {
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced ? "auto" : "smooth" });
    return;
  }
  el.scrollIntoView({ behavior: prefersReduced ? "auto" : "smooth", block: "start" });
}
